import React, { useCallback, useEffect, useRef, useState } from "react";
import { ResponsivePie } from "@nivo/pie";
import axios from "axios";
import { ResponsiveLine } from "@nivo/line";

import Utilities from "../lib/Utilities";
import { MsgIDList } from "../lib/BuddibleSocket";

const util = new Utilities();

const _serverUrlList = [
  "https://system.gbts.co.kr:9910/monitor",
  "https://talktalk.gbts.co.kr:9910/monitor",
  "https://winwas.gbts.co.kr:9910/monitor",
];

const _serverList = [
  {
    lineCharts: [
      {
        id: "cpuHistory",
        desc: "CORES 4 LOAD 64.06%",
        data: [
          {
            x: "17:38:18",
            y: 40,
            realValue: 40.1419654877004,
          },
          {
            x: "17:38:28",
            y: 40,
            realValue: 40.52135601517562,
          },
          {
            x: "17:38:38",
            y: 41,
            realValue: 41.391261294714695,
          },
          {
            x: "17:38:48",
            y: 35,
            realValue: 35.908141962421716,
          },
          {
            x: "17:38:58",
            y: 42,
            realValue: 42.29249011857708,
          },
          {
            x: "17:39:08",
            y: 43,
            realValue: 43.878042901904074,
          },
        ],
        load: 64.05716060888474,
        cores: 4,
        name: "CPU HISTORY",
        keys: ["load"],
      },
      {
        id: "memoryHistory",
        desc: "사용량 : 91.95% 1.82/1.98 GB",
        data: [
          {
            x: "17:38:18",
            y: 91,
            realValue: 91.972513630427,
          },
          {
            x: "17:38:28",
            y: 91,
            realValue: 91.97912232230398,
          },
          {
            x: "17:38:38",
            y: 91,
            realValue: 91.97574561842524,
          },
          {
            x: "17:38:48",
            y: 91,
            realValue: 91.97328544845642,
          },
          {
            x: "17:38:58",
            y: 91,
            realValue: 91.89460824808161,
          },
          {
            x: "17:39:08",
            y: 91,
            realValue: 91.95982687156827,
          },
        ],
        free: 1366360064,
        total: 16982241280,
        used: 15615881216,
        percentUsed: 91.95418295222808,
        name: "MEMORY HISTORY",
        keys: ["percentUsed"],
      },
    ],
    pieCharts: [
      {
        id: "DISKS",
        fs: "C:",
        type: "NTFS",
        size: 103076065280,
        used: 92344254464,
        available: 10731810816,
        use: 89.59,
        mount: "C:",
        rw: true,
        desc: "사용량 : 89.59% 10.75/12.00 GB",
        charts: [
          {
            id: "USAGE",
            value: 89.58845510172738,
            color: "#0097B7",
          },
          {
            id: "AVAILABLE",
            value: 10.411544898272625,
            color: "#334D80",
          },
        ],
      },
    ],
    platform: "win32",
    release: "10.0.14393",
    arch: "x64",
  },
];
let loadCount = 1;
let sv = [];

export default function Test() {
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [isDisplayReset, setIsDisplayReset] = useState(false);
  const [serverList, setServerList] = useState([..._serverList]);
  const [errorList, setErrorList] = useState([null, null, null]);
  const [lastUpdate, setLastUpdate] = useState([null, null, null]);
  const [loadingList, setLoadingList] = useState([true, true, true]);

  useEffect(() => {
    getHardwareMonitor();
    const intervalRequest = setInterval(() => {
      getHardwareMonitor();
    }, 1000 * 10);
    return () => {
      clearInterval(intervalRequest);
    };
  }, []);

  function getHardwareMonitor() {
    const username = "admin";
    const password = "GbtS9880!@";
    const base64Credentials = Buffer.from(`${username}:${password}`).toString(
      "base64"
    );
    const authHeader = `Basic ${base64Credentials}`;
    if (loadCount === 60 * _serverUrlList.length) {
      loadCount = 1;
      setIsDisplayReset(true);
    }
    let newErrorList = [...errorList];
    let newLastUpdate = [...lastUpdate];
    let newLoadingList = [true, true, true];
    _serverUrlList.forEach((url, index) => {
      axios
        .get(url, {
          headers: {
            Authorization: authHeader,
          },
        })
        .then((response) => {
          setData(response.data, (data) => {
            if (
              sv.length === _serverUrlList.length &&
              sv.findIndex((i) => !i) === -1
            ) {
              setServerList(sv);
              sv = [];
            } else {
              sv[index] = data;
            }
            newErrorList[index] = null;
            newLastUpdate[index] = new Date();
            newLoadingList[index] = false;
            setErrorList([...newErrorList]);
            setLastUpdate([...newLastUpdate]);
            setLoadingList([...newLoadingList]);
          });
        })
        .catch((error) => {
          newErrorList[index] =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          newLoadingList[index] = false;
          setErrorList([...newErrorList]);
          setLoadingList([...newLoadingList]);
        })
        .finally(() => {
          loadCount++;
          setIsDisplayReset(false);
        });
    });
  }

  function getTime(date) {
    if (!date) return "-";
    const time = new Date(date);
    const hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
    const min =
      time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
    const sec =
      time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
    return `${hour}:${min}:${sec}`;
  }

  function bytesToGigabytes(bytes) {
    return bytes / 1024 ** 3;
  }

  function setData(data, callback) {
    let temp = {};
    for (let key in data) {
      if (key === "os") {
        temp = {
          ...temp,
          ...data[key],
        };
      }

      if (key === "memory" || key === "cpu") {
        const isCPU = key === "cpu";
        const hisKey = key + "History";
        let desc = ""; //`CORES ${data[key].cores} LOAD ${data[key].load}\n`;
        if (isCPU) {
          desc = `CORES ${data[key].cores} LOAD ${data[key].load.toFixed(2)}%`;
        } else {
          desc = `사용량 : ${data[key].percentUsed.toFixed(
            2
          )}% ${util.addCommas(
            bytesToGigabytes(data[key].used).toFixed(2)
          )}/${util.addCommas(
            bytesToGigabytes(data[key].total).toFixed(2)
          )} GB`;
        }

        const setData = {
          id: key,
          desc: desc,
          data: [],
          ...data[key],
        };

        if (temp.hasOwnProperty("lineCharts")) {
          const index = temp["lineCharts"].findIndex(
            (bar) => bar.id === hisKey
          );

          if (index > -1) {
            temp["lineCharts"][index] = {
              ...setData,
              ...temp["lineCharts"][index],
            };
          } else {
            temp["lineCharts"].push(setData);
          }
        } else {
          temp["lineCharts"] = [setData];
        }
      }

      if (key === "cpuHistory" || key === "memoryHistory") {
        const isCPU = key === "cpuHistory";
        const name = isCPU ? "CPU HISTORY" : "MEMORY HISTORY";
        const keys = isCPU ? ["load"] : ["percentUsed"];

        let pushData = {
          id: key,
          name: name,
          keys: keys,
          data: [],
        };

        const sliceData = data[key].slice(-5);
        for (let j = 0; j < sliceData.length; j++) {
          const y = isCPU ? sliceData[j].load : sliceData[j].percentUsed;
          const x = 50 - j * 10;
          pushData.data.push({
            x: `-${x}sec`, //getTime(sliceData[j].timestamp),
            y: parseInt(y),
            realValue: y,
          });
        }

        if (temp.hasOwnProperty("lineCharts")) {
          temp["lineCharts"].push(pushData);
        } else {
          temp["lineCharts"] = [{ ...pushData }];
        }
      }

      if (key === "disks") {
        temp["pieCharts"] = [];
        for (let j = 0; j < data[key].length; j++) {
          temp["pieCharts"].push({
            id: key.toUpperCase(),
            ...data[key][j],
            desc: `사용량 : ${data[key][j].use}% ${util.addCommas(
              bytesToGigabytes(data[key][j].used).toFixed(2)
            )}/${util.addCommas(
              bytesToGigabytes(data[key][j].size).toFixed(2)
            )} GB`,
            charts: [
              {
                id: "USAGE",
                value: (data[key][j].used / data[key][j].size) * 100,
                color: "#0097B7",
              },
              {
                id: "AVAILABLE",
                value: (data[key][j].available / data[key][j].size) * 100,
                color: "#334D80",
              },
            ],
          });
        }
      }
    }

    callback(temp);
  }

  // 임계치 경고 색상 함수
  function getCardBorderColor(server) {
    // 디스크, 메모리, CPU 중 하나라도 80% 이상이면 경고
    let danger = false;
    if (server.pieCharts && server.pieCharts[0] && server.pieCharts[0].use >= 90) danger = true;
    if (server.lineCharts && server.lineCharts.find(lc => lc.id === "memory") && server.lineCharts.find(lc => lc.id === "memory").percentUsed >= 90) danger = true;
    if (server.lineCharts && server.lineCharts.find(lc => lc.id === "cpu") && server.lineCharts.find(lc => lc.id === "cpu").load >= 90) danger = true;
    return danger ? "2px solid #ff3b3b" : "2px solid rgba(255,255,255,0.15)";
  }

  // 카드 배경색도 임계치에 따라 살짝 강조
  function getCardBgColor(server) {
    let danger = false;
    if (server.pieCharts && server.pieCharts[0] && server.pieCharts[0].use >= 90) danger = true;
    if (server.lineCharts && server.lineCharts.find(lc => lc.id === "memory") && server.lineCharts.find(lc => lc.id === "memory").percentUsed >= 90) danger = true;
    if (server.lineCharts && server.lineCharts.find(lc => lc.id === "cpu") && server.lineCharts.find(lc => lc.id === "cpu").load >= 90) danger = true;
    return danger ? "rgba(255,59,59,0.12)" : "rgba(255,255,255,0.08)";
  }

  // 반응형 레이아웃 스타일
  const dashboardStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "24px",
    padding: "24px 0",
  };

  return (
    <main className="bg-freiscop text-white position-relative min-vh-100" style={{minHeight:'100vh'}}>
      {isDisplayReset && (
        <div
          className="position-fixed vh-100 vw-100"
          style={{ zIndex: 999, background: "#000000" }}
        />
      )}
      <p className="h1 m-0 px-2 pt-2 font-weight-bold" style={{letterSpacing:'2px'}}>DASH BOARD</p>
      <div style={dashboardStyle}>
        {serverList.map((server, index) => {
          const url = new URL(_serverUrlList[index]);
          let serverName = url.hostname.split(".");
          serverName = serverName[0] + "." + serverName[1];

          // 카드 크기 계산 (반응형)
          const cardWidth = Math.min(400, Math.floor(window.innerWidth / 3) - 24);
          const cardHeight = 420;

          // 임계치 경고
          const borderColor = getCardBorderColor(server);
          const bgColor = getCardBgColor(server);

          return (
            <div
              key={index}
              className="rounded-lg shadow position-relative"
              style={{
                width: cardWidth,
                minWidth: 280,
                maxWidth: 420,
                height: cardHeight,
                margin: "0 auto",
                background: bgColor,
                border: borderColor,
                boxShadow: "0 2px 16px 0 rgba(0,0,0,0.12)",
                padding: 18,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                overflow: 'hidden',
              }}
            >
              {/* 로딩 오버레이 */}
              {loadingList[index] && (
                <div style={{
                  position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0,
                  background: 'rgba(0,0,0,0.15)',
                  zIndex: 10,
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  pointerEvents: 'none',
                }}>
                  <div style={{margin: 16, display:'flex', alignItems:'center', gap:8}}>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span style={{fontSize:14}}>로딩 중...</span>
                  </div>
                </div>
              )}
              <div style={{display:'flex',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
                <p className="h4 mb-0 font-weight-bold" style={{letterSpacing:'1px'}}>{serverName}</p>
                <span style={{fontSize:12,opacity:0.7}}>갱신: {getTime(lastUpdate[index])}</span>
              </div>
              {/* 에러 표시 */}
              {errorList[index] ? (
                <div style={{color:'#ff3b3b',marginTop:40,fontWeight:'bold',width:'100%',textAlign:'center'}}>연결 실패<br/>{errorList[index]}</div>
              ) : (
                <>
                  {/* 도넛 차트 */}
                  {server.pieCharts.map((data, idx) => (
                    <div
                      key={idx}
                      style={{width:'100%',display:'flex',alignItems:'center',marginTop:10,marginBottom:10}}
                    >
                      <div style={{width:110,height:110,position:'relative'}}>
                        <MyResponsivePie
                          data={data.charts}
                          diameter={110}
                          use={data.use}
                        />
                        <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',textAlign:'center'}}>
                          <span style={{fontWeight:'bold',fontSize:22,color:data.use>=90?'#ff3b3b':'#00d8ff'}}>{data.use}%</span><br/>
                          <span style={{fontSize:12,opacity:0.8}}>{data.used && data.size ? `${util.addCommas(bytesToGigabytes(data.used).toFixed(2))}/${util.addCommas(bytesToGigabytes(data.size).toFixed(2))}GB` : ''}</span>
                        </div>
                      </div>
                      <div style={{marginLeft:18}}>
                        <div style={{fontWeight:'bold',fontSize:16}}>{data.id} {data.mount}</div>
                        <div style={{fontSize:13,opacity:0.7}}>{data.desc}</div>
                      </div>
                    </div>
                  ))}
                  {/* 라인 차트 */}
                  <div style={{display:'flex',width:'100%',gap:8,marginTop:8}}>
                    {server.lineCharts.map((data, idx) => (
                      <div key={data.id} style={{width:'50%', minWidth:120, height: 220, marginBottom: 8}}>
                        <div style={{fontWeight:'bold',fontSize:14}}>{data.name}</div>
                        <div style={{fontSize:12,opacity:0.7}}>{data.desc}</div>
                        <div style={{height: 220, width: '100%'}}>
                          <MyResponsiveLine
                            data={data}
                            keys={data.keys}
                            indexBy="timestamp"
                            unit={data.id==="memory"||data.id==="memoryHistory"?"%":"%"}
                            height={170}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </main>
  );
}

// 도넛 차트 개선: 임계치 색상, 중앙 텍스트, 단위
const MyResponsivePie = ({ data, innerRadius, diameter, use }) => {
  return (
    <ResponsivePie
      data={data}
      colors={(event) => {
        // 임계치 색상
        if (event.data.id === "USAGE") {
          return use >= 90 ? "#ff3b3b" : "#0097B7";
        }
        return event.data.color;
      }}
      width={diameter || 80}
      height={diameter || 80}
      startAngle={0}
      endAngle={360}
      innerRadius={innerRadius || 0.8}
      enableArcLabels={false}
      enableArcLinkLabels={false}
      margin={{top:0,right:0,bottom:0,left:0}}
    />
  );
};

// 라인 차트 개선: Y축 단위, 툴팁, 색상
const MyResponsiveLine = ({ data, keys, indexBy, unit, height }) => {
  return (
    <ResponsiveLine
      data={[data]}
      colors={data.id==="memory"||data.id==="memoryHistory"?"#00d8ff":"#0097B7"}
      theme={{
        textColor: "#ffffff",
        fontSize: 10,
        axis: {
          domain: { line: { stroke: "#ffffff", strokeWidth: 1 } },
          ticks: {
            line: { stroke: "#ffffff", strokeWidth: 1 },
            text: { fill: "#ffffff" },
          },
          legend: { text: { fill: "#ffffff" } },
        },
        legends: { text: { fill: "#ffffff" } },
        tooltip: {
          container: {
            background: "#333333",
            color: "#ffffff",
            fontSize: 12,
          },
        },
      }}
      yFormat={">-.2f"}
      maxValue={100}
      minValue={0}
      margin={{ top: 6, right: 20, bottom: 30, left: 30 }}
      pointSize={8}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabel="data.yFormatted"
      pointLabelYOffset={-12}
      enableTouchCrosshair={true}
      useMesh={true}
      yScale={{
        type: "linear",
        min: 0,
        max: 100,
      }}
      axisLeft={{
        tickValues: [0, 20, 40, 60, 80, 100],
        legend: unit || "%",
        legendOffset: -24,
        legendPosition: "middle",
      }}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "시간",
        legendOffset: 28,
        legendPosition: "middle",
      }}
      tooltip={({ point }) => (
        <div
          className="p-2 rounded text-white"
          style={{ background: "rgba(0,0,0,.8)" }}
        >
          {point.data.xFormatted} : {point.data.realValue.toFixed(2)}{unit || "%"}
        </div>
      )}
      height={height || 230}
    />
  );
};

